'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (component, errorInput) {
  if (!errorInput.graphQLErrors) return showMessage(component, errorInput);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = errorInput.graphQLErrors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var error = _step.value;

      if (!error || !error.details) return showMessage(component, error);
      var errorMessages = error.details.invalidKeys;
      if (!errorMessages) return showMessage(component, error);
      component.setState({ errorMessages: errorMessages });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var showMessage = function showMessage(component, error) {
  var show = component.props.showMessage;
  if (!show) return;
  show(error.message, { level: 'error' });
};